import React from "react";
import DeviceInformationForm from "../DeviceInformationForm";

const SecondaryDeviceInformationForm = ({
  isLoading,
  handleCancelClick,
  handleSubmit,
}) => {
  return (
    <DeviceInformationForm
      isPrimaryDevice={false}
      handleCancelClick={handleCancelClick}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
    />
  );
};

export default SecondaryDeviceInformationForm;
